import { API } from "@/lib/api";

export const MOODS = [
  { id: "mithai", name: "Mithai Enthusiast", line: "Here for the sweets and second helpings." },
  { id: "dance", name: "Dance Floor Regular", line: "One song away from starting the party." },
  { id: "cards", name: "Cards Table Captain", line: "A little luck. A lot of confidence." },
  { id: "conversation", name: "Courtyard Conversationalist", line: "Here for the catch ups that run late." },
];

export const PASS_ACCENT = { hex: "#FFC83D", soft: "#FFF0C2" };

export function splitTitle(title = "") {
  const words = title.trim().split(/\s+/);
  const last = words.length > 1 ? words.pop() : "";
  return { l1: words.slice(0, 2).join(" "), l2: words.slice(2).join(" "), last };
}

export const moodById = (id) => MOODS.find((m) => m.id === id) || null;

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function formatDate(iso, withDay = true) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  if (!m) return "";
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  const core = `${+m[3]} ${MONTHS[+m[2] - 1]} ${m[1]}`;
  return withDay ? `${DAYS[d.getUTCDay()]}, ${core}` : core;
}

export function formatTime(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || "");
  if (!m) return "";
  const h = +m[1];
  return `${h % 12 || 12}:${m[2]} ${h < 12 ? "AM" : "PM"}`;
}

export const inviteLink = (ev) => (ev?.public_url || window.location.origin).replace(/\/$/, "");

export const mapLink = (ev) =>
  ev?.map_url || (ev?.address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ev.address)}` : "");

export function googleCalLink(ev) {
  if (!ev?.calendar_ready) return "";
  const link = inviteLink(ev);
  const details = [ev.message, `Venue: ${ev.venue_title || ""}`, mapLink(ev) && `Map: ${mapLink(ev)}`, link && `Invitation: ${link}`].filter(Boolean).join("\n\n");
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.title,
    dates: `${ev.start_local}/${ev.end_local}`,
    ctz: ev.timezone,
    location: ev.venue_title || "",
    details,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

export const icsLink = (ev) => `${API}/calendar.ics?link=${encodeURIComponent(inviteLink(ev))}`;

export const shareText = (ev) =>
  `${ev.title}: ${formatDate(ev.date, false)}, ${formatTime(ev.start_time)}. ${ev.tagline} Tum bas aa jaana:`;

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const target = () => el.getBoundingClientRect().top + window.scrollY - 64;
  if (window.__lenis) {
    window.__lenis.scrollTo(target(), {
      onComplete: () => {
        const off = el.getBoundingClientRect().top - 64;
        if (Math.abs(off) > 6) window.__lenis.scrollTo(target(), { immediate: true });
      },
    });
  } else window.scrollTo({ top: target(), behavior: "smooth" });
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
}
